export default "/kiban/_next/static/images/01_4L_none-88d2f9e2ca565e14622c04b5f5e07695.png";